// extracted by mini-css-extract-plugin
module.exports = {"slot":"DayNight_slot__vqfoh","icon":"DayNight_icon__3XnSu","pic":"DayNight_pic__APStm","label":"DayNight_label__2i-ae"};